
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.event-summary {
    padding-right: 20px
}
@media (min-width: 768px) {
    .event-summary {
        padding-right: 100px
    }
}
@media (min-width: 1024px) {
    .event-summary {
        padding-right: 180px
    }
}
`;